import React, { useEffect, useState } from "react";
import i18n from "utils/i18n";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { useShowHamburger } from 'utils/helper-device'
import _ from 'lodash'
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { AppRoutes } from 'navigations/app-routes'
import { colorList } from 'utils/colors'
import { timeslotKindConstants, timeslotSubKindConstants } from 'utils/constants/timeslot-kind-constants'
import { IconTimeslotConstants } from 'utils/constants/IconNameConstants'
import TimeslotIcon from 'components/molecules/TimeslotIcon'
import { StyleSheet, View } from 'react-native'
import { listArrow } from 'styles/list'
import ManagementGroupedThemeList from 'components/management/molecules/ManagementGroupedThemeList'
import ListItem from 'components/atoms/ListItem'


const ManagementTimeslotKindAddScene = () => {
	const showHamburger = useShowHamburger();
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	
	const [ availableCustomSubKinds, setAvailableCustomSubKinds ] = useState([]);
	const [ isLoading, setIsLoading ] = useState( false );
	
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	
	const fetchedTimeslotKinds = ( timeslotKinds ) => {
		let tmpAvailableCustomSubKinds = [];
		_.forEach( timeslotSubKindConstants, ( timeslotSubKindConstant ) => {
			if( _.includes( timeslotSubKindConstant, 'custom' ) ) {
				tmpAvailableCustomSubKinds.push( timeslotSubKindConstant );
			}
		});
		
		_.forEach( timeslotKinds, ( timeslotKind ) => {
			tmpAvailableCustomSubKinds = _.without( tmpAvailableCustomSubKinds, timeslotKind.sub_kind );
		});
		
		setAvailableCustomSubKinds( tmpAvailableCustomSubKinds );
		
		loaded();
	}
	
	const fetchTimeslotKinds = () => {
		if( !isLoading ){
			FetchTimeslotKinds.fetchAll({
				callbackStart: loading,
				callbackError: loaded,
				callbackSuccess: fetchedTimeslotKinds
			});
		}
	}
	
	useEffect( () => {
		fetchTimeslotKinds();
	}, [] );
	
	useEffect( () => {
		if( isFocused ) {
			fetchTimeslotKinds();
		}
	}, [ isFocused ] );
	
	
	const addableTimeslotKinds = [];
	_.forEach( timeslotKindConstants, ( timeslotKindConstant ) => {
		let timeslotIconOverWriteProperties = {};
		
		let backgroundColor = colorList.GREY.primary;
		let icon = null;
		
		switch( timeslotKindConstant ){
			case timeslotKindConstants.BOOKING:
				backgroundColor = colorList.ORANGE.primary;
				icon = IconTimeslotConstants.WORKPLACE;
				break;
				
			case timeslotKindConstants.TRANSPORT:
				backgroundColor = colorList.GREEN.primary;
				icon = IconTimeslotConstants.CAR;
				break;
				
			case timeslotKindConstants.LUNCH:
				backgroundColor = colorList.BLUE.primary;
				icon = IconTimeslotConstants.LUNCH;
				break;
				
			case timeslotKindConstants.MEETING_ROOM:
				backgroundColor = colorList.PURPLE.primary;
				icon = IconTimeslotConstants.MEETING_ROOM;
				break;
				
			case timeslotKindConstants.CUSTOM:
				backgroundColor = colorList.GREY.dark;
				icon = IconTimeslotConstants.QUESTION_MARK;
				break;
		}
		
		timeslotIconOverWriteProperties = {
			background_color: backgroundColor,
			icon: icon
		};
		
		addableTimeslotKinds.push({
			title: i18n.t(`constants.timeslots.${timeslotKindConstant}`),
			kind: timeslotKindConstant,
			sub_kind: availableCustomSubKinds[ 0 ],
			icon: 	<TimeslotIcon
				timeslot={ timeslotIconOverWriteProperties }
				overWriteProperties={ timeslotIconOverWriteProperties}
			/>
		});
	});
	
	const createTimeslotKind = ( item ) => {
		navigation.navigate( AppRoutes.MANAGEMENT_TIMESLOT_KINDS, {
			kind: item?.kind,
			sub_kind: item?.sub_kind
		} );
	};
	
	const renderItem = ( { item, index } ) => {
		return (
			<ListItem
				title={ item.title }
				//title_add_active_tag={ true }
				item={ item }
				accessoryLeft={ <View style={ staticStyles.viewWidth45Height45 }>{ item.icon }</View> }
				accessoryLeftSize={ 60 }
				accessoryRight={ listArrow }
				onPress={ createTimeslotKind }
			/>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t( 'management:pages.timeslots.timeslotKinds.title') }
				topNavigation={true}
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}
				showBackButton={ true }>
				
				<ManagementGroupedThemeList
					items={ addableTimeslotKinds }
					renderItem={ renderItem.bind( this ) }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const staticStyles = StyleSheet.create({
	viewWidth45Height45: {
		width: 45,
		height: 45,
		marginRight: 5,
	},
});

export default ManagementTimeslotKindAddScene
